var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('my-map'), _vm._v(" "), _c('div', {
    staticClass: "row location-text",
    attrs: {
      "id": "our-centers"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Our Locations")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "card bg-light mb-3"
  }, [_c('div', {
    staticClass: "card-header bg-warning"
  }, [_vm._v("Registered Office")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Haridwar Main Office")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Address:")]), _vm._v(" 344 MIG, Vivek Vihar Colony, Ranipur More, Haridwar")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(" +91 9412073651")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Email:")]), _vm._v(" friendshwr@gmail.com")])])])])]), _vm._v(" "), _vm._l((_vm.centersArr), function(center) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('transition', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "appear": ""
      }
    }, [_c('div', {
      staticClass: "card bg-light mb-3"
    }, [_c('div', {
      staticClass: "card-header bg-warning"
    }, [_vm._v("Urban Primary Health Center")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(center.centerName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Address:")]), _vm._v(" " + _vm._s(center.address))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(" +91 9412073651")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("Email:")]), _vm._v(" friendshwr@gmail.com")])])])])], 1)
  })], 2)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-423ec96a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact/Contact.vue
// module id = zqbm
// module chunks = 0